<template>
  <input
    ref="inputElement"
    v-model="handleInputValue"
    :type="inputType"
    :placeholder="placeholderValue"
    class="inputItem"
    :class="{ disabled: disabled }"
    :disabled="disabled"
    :maxlength="maxlength"
    :autocomplete="autocompleteValue"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
  />
</template>

<script>
export default {
  name: 'InputItem',
  model: {
    prop: 'inputValue',
    event: 'change',
  },
  props: {
    inputType: {
      default: 'text',
      validator(value) {
        return ['text', 'password', 'number', 'tel'].indexOf(value) !== -1;
      },
    },
    placeholderValue: {
      type: String,
      required: false,
      default: '',
    },
    inputValue: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    maxlength: {
      type: String,
      required: false,
      default: '',
    },
    // 先頭と末尾のスペースをトリムするフラグ
    trimSpaceStartEnd: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    // autocomplete属性に"new-password"を設定するかどうか
    isNewPassword: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    handleInputValue: {
      get() {
        return this.inputValue;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
    autocompleteValue() {
      return this.isNewPassword ? 'new-password' : 'off';
    },
  },
  watch: {
    inputValue() {
      if (!this.trimSpaceStartEnd) return;
      // 先頭のスペースのみ削除。文字間のスペースは許容のため、末尾スペースはblur時にtrim
      const trimValue = this.inputValue.trimStart();
      if (this.inputValue !== trimValue) {
        this.$emit('change', trimValue);
      }
    },
    disabled(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          if (!this.inputValue) {
            this.$refs.inputElement.focus();
          }
        });
      }
    },
  },
  methods: {
    onBlur(event) {
      if (this.trimSpaceStartEnd) {
        const trimValue = this.inputValue.trimEnd();
        if (this.inputValue !== trimValue) {
          this.$emit('change', trimValue);
        }
      }

      this.$emit('blur', event);
    },
    onFocus(event) {
      // 単純emit
      this.$emit('focus', event);
    },
    onInput(event) {
      this.$emit('input', event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.inputItem {
  background-color: $color-background-primary-third-light;
  border: $border-sapuri-white-light;
  border-radius: 6px;
  height: 48px;
  width: 100%;
  box-sizing: border-box;
  font-size: $text-size-paragraph2;
  color: $color-text-primary;
  padding: 12px;

  &.disabled {
    color: $color-text-spot-caption;
    pointer-events: none;
    background-color: $color-background-primary-third;
  }

  &::placeholder {
    line-height: $text-line-height-default;
    font-size: $text-size-paragraph2;
    color: $color-text-spot-caption;
  }

  &:focus {
    outline: none;
    border: solid 1px $color-action-primary;
  }
}
</style>
